import React from 'react';

const iconPrint = ({ className }) => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className={className || ''}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-751.000000, -346.000000)" fill="#27919C">
        <g id="icon_print" transform="translate(751.000000, 346.000000)">
          <path
            d="M5.13905828,10.8 L11.9609417,10.8 C12.8107053,10.8 13.5,11.5275255 13.5,12.4243689 L13.5,16.374737 C13.5,17.2724979 12.8106836,18 11.9609417,18 L5.13905828,18 C4.2892947,18 3.6,17.2724749 3.6,16.374737 L3.6,12.4243689 C3.6,11.5275026 4.28931643,10.8 5.13905828,10.8 Z M5.13905828,12.2335366 C5.03888693,12.2335366 4.95824175,12.3195488 4.95824175,12.4243758 L4.95824175,16.3747439 C4.95824175,16.4804678 5.03888693,16.56648 5.13905828,16.56648 L11.9609417,16.56648 C12.0611131,16.56648 12.1417582,16.4804678 12.1417582,16.3747439 L12.1417582,12.4243758 C12.1417582,12.3195488 12.0611131,12.2335366 11.9609417,12.2335366 L5.13905828,12.2335366 Z"
            id="Fill-1"
          />
          <path
            d="M4.17671279,1.40859863 L12.9231927,1.40859863 L12.9231927,4.35999967 L14.4,4.35999967 L14.4,1.24585909 C14.4,0.557326577 13.8157278,0 13.0939589,0 L4.00604113,0 C3.2842486,0 2.7,0.557349117 2.7,1.24585909 L2.7,5.4 L4.17680731,5.4 L4.17671279,1.40859863 Z"
            id="Fill-2"
          />
          <path
            d="M12.375,7.2 L13.725,7.2 C14.0979456,7.2 14.4,7.4486304 14.4,7.65 C14.4,7.8986304 14.0979456,8.1 13.725,8.1 L12.375,8.1 C12.0020544,8.1 11.7,7.8513696 11.7,7.65 C11.7,7.4013696 12.0020544,7.2 12.375,7.2 Z"
            id="Fill-3"
          />
          <path
            d="M4.22864333,14.7988964 L2.6762058,14.7988964 C2.003967,14.7988964 1.45943232,14.2761166 1.45943232,13.6307346 L1.45943232,7.06841352 C1.45943232,6.42390585 2.003967,5.90112606 2.6762058,5.90112606 L15.3237942,5.90112606 C15.996033,5.90112606 16.5405677,6.42390585 16.5405677,7.06841352 L16.5405677,13.6307346 C16.5405677,14.2761166 15.996033,14.7988964 15.3237942,14.7988964 L13.9683652,14.7988964 C13.5651947,14.7988964 13.2386607,15.1123849 13.2386607,15.4994482 C13.2386607,15.8856372 13.5651947,16.2 13.9683652,16.2 L15.3237942,16.2 C16.80144,16.2 18,15.0493464 18,13.6307122 L18,7.0683911 C18,5.64977927 16.8014633,4.5 15.3237942,4.5 L2.6762058,4.5 C1.19856005,4.5 0,5.64977927 0,7.0683911 L0,13.6307122 C0,15.049324 1.1985367,16.2 2.6762058,16.2 L4.22864333,16.2 C4.63181382,16.2 4.95834782,15.8856372 4.95834782,15.4994482 C4.95834782,15.1123849 4.63181382,14.7988964 4.22864333,14.7988964 Z"
            id="Fill-4"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default iconPrint;
